<template>
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
             <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initAddSpeakerItem">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="tableSpeakers"
            :loading="isSpeakerItemPending"
            @pagination="currentPagination"
        >
            <template v-slot:item.scroller="{value}">
                <div v-show="isEditOrderMode" class="handle">
                    <v-btn icon><v-icon>drag_handle{{value}}</v-icon></v-btn>
                </div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <!-- <span :key="item.itemOrder"></span> -->
            <template v-slot:item.createdAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.updatedAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.order="{value}">
                {{value}}
            </template>
            <template v-slot:item.photo="{value}">
                <v-img v-if="value" :src="getFileUrl(value)" max-width="5rem" max-height="5rem"></v-img>
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn
                    color="primary"
                    class="ma-2"
                    @click="initEditSpeakerItem(item)"
                >{{$t('edit')}}<v-icon right>mdi-pencil</v-icon></v-btn>
                <v-btn
                    color="red"
                    dark
                    class="ma-2"
                    @click="deleteSpeakerItem(item)"
                >{{$t('delete')}}<v-icon right>mdi-delete</v-icon></v-btn>
            </template>
        </v-data-table>

        <v-dialog
            v-model="editSpeakerItemDialogShown"
            max-width="600px"
            persistent
            scrollable
            :retain-focus="false"
        >
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditSpeakerItemFormValid">
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        :label="$t('speaker_item.order')"
                                        :placeholder="$t('speaker_item.order')"
                                        :rules="[speakerOrderRule]"
                                        v-model="editingSpeakerItem.order"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('speaker_item.type')"
                                        :placeholder="$t('speaker_item.type')"
                                        v-model="editingSpeakerItem.type"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('speaker_item.token')"
                                        :placeholder="$t('speaker_item.token')"
                                        v-model="editingSpeakerItem.token"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-file-input accept="image/*"
                                    :label="$t('speaker_item.photo')"
                                    v-model="editingSpeakerItem.photo"
                                >
                                    <template
                                        v-slot:selection="{file}"
                                    >
                                        <v-img
                                            :src="getFileUrl(file)"
                                            max-width="250px"
                                            max-height="250px"
                                        ></v-img>
                                    </template>
                                </v-file-input>
                            </v-row>
                            <!-- English (default) -->
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        :label="$t('speaker_item.name')"
                                        :placeholder="$t('speaker_item.name')"
                                        v-model="editingSpeakerItem.name"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('speaker_item.lastname')"
                                        :placeholder="$t('speaker_item.lastname')"
                                        v-model="editingSpeakerItem.lastname"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-textarea outlined
                                        :label="$t('speaker_item.title')"
                                        :placeholder="$t('speaker_item.title')"
                                        v-model="editingSpeakerItem.title"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('speaker_item.company')"
                                        :placeholder="$t('speaker_item.company')"
                                        v-model="editingSpeakerItem.company"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('speaker_item.bio')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.bio"
                                    ></froala>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col class="py-0">{{$t('speaker_item.speaks_at')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.speaks_at"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <!-- Simplified Chinese -->
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        :label="'SC ' + $t('speaker_item.name')"
                                        :placeholder="$t('speaker_item.name')"
                                        v-model="editingSpeakerItem.name__sc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-textarea outlined
                                        :label="'SC ' + $t('speaker_item.title')"
                                        :placeholder="$t('speaker_item.title')"
                                        v-model="editingSpeakerItem.title__sc"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="'SC ' + $t('speaker_item.company')"
                                        :placeholder="$t('speaker_item.company')"
                                        v-model="editingSpeakerItem.company__sc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'SC ' + $t('speaker_item.bio')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.bio__sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'SC ' + $t('speaker_item.speaks_at')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.speaks_at__sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <!-- Traditional Chinese -->
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        :label="'TC ' + $t('speaker_item.name')"
                                        :placeholder="$t('speaker_item.name')"
                                        v-model="editingSpeakerItem.name__tc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-textarea outlined
                                        :label="'TC ' + $t('speaker_item.title')"
                                        :placeholder="$t('speaker_item.title')"
                                        v-model="editingSpeakerItem.title__tc"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="'TC ' + $t('speaker_item.company')"
                                        :placeholder="$t('speaker_item.company')"
                                        v-model="editingSpeakerItem.company__tc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'TC ' + $t('speaker_item.bio')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.bio__tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'TC ' + $t('speaker_item.speaks_at')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.speaks_at__tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <!-- ID -->
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        :label="'ID ' + $t('speaker_item.name')"
                                        :placeholder="$t('speaker_item.name')"
                                        v-model="editingSpeakerItem.name__id"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-textarea outlined
                                        :label="'ID ' + $t('speaker_item.title')"
                                        :placeholder="$t('speaker_item.title')"
                                        v-model="editingSpeakerItem.title__id"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="'ID ' + $t('speaker_item.company')"
                                        :placeholder="$t('speaker_item.company')"
                                        v-model="editingSpeakerItem.company__id"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'ID ' + $t('speaker_item.bio')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.bio__id"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'ID ' + $t('speaker_item.speaks_at')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.speaks_at__id"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <!-- VN -->
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        :label="'VN ' + $t('speaker_item.name')"
                                        :placeholder="$t('speaker_item.name')"
                                        v-model="editingSpeakerItem.name__vn"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-textarea outlined
                                        :label="'VN ' + $t('speaker_item.title')"
                                        :placeholder="$t('speaker_item.title')"
                                        v-model="editingSpeakerItem.title__vn"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="'VN ' + $t('speaker_item.company')"
                                        :placeholder="$t('speaker_item.company')"
                                        v-model="editingSpeakerItem.company__vn"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'VN ' + $t('speaker_item.bio')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.bio__vn"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{'VN ' + $t('speaker_item.speaks_at')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingSpeakerItem.speaks_at__vn"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn
                        color="secondary"
                        @click="confirmCancelItemDialogShown=true"
                    >{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="primary"
                        @click="saveSpeakerItem"
                        :disabled="!isEditSpeakerItemFormValid"
                    >{{$t('save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PopupAlert
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditSpeakerItem"
            :onNo="function(){confirmCancelItemDialogShown=false;}"
        ></PopupAlert>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>
<style scoped>
    .button-spacer {
        width:10px;
    }
</style>
<script>
    import {computed, ref, onMounted} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import Sortable from "sortablejs";
    import * as lodash from "lodash";
    import PopupAlert from "../../components/PopupAlert";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventSpeakerItemList',
        props: {
            speakerId: String,
        },
        components:{PopupAlert},
        setup(props, {root}) {
            const {SpeakerItem} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const speakerItemParams = computed(() => {
                return {
                    query: {
                        fSpeakerId: props.speakerId,
                        $sort: {order: 1},
                    }
                }
            });
            const speakerItemQueryWhen = computed(() => {
                return !!props.speakerId;
            });
            const {items: speakerItems, isPending: isSpeakerItemPending} = useFind({
                model: SpeakerItem,
                params: speakerItemParams,
                queryWhen: speakerItemQueryWhen,
            });

            // Data Table
            const headers = ref([
                {text: '', value:'scroller',width:80},
                {text: root.$t('speaker_item.order'), value:'order'},
                {text: root.$t('speaker_item.photo'), value: 'photo'},
                {text: root.$t('speaker_item.name'), value: 'name'},
                {text: root.$t('speaker_item.lastname'), value: 'lastname'},
                {text: root.$t('speaker_item.title'), value: 'title'},
                {text: root.$t('speaker_item.company'), value: 'company'},
                // {text: root.$t('speaker_item.bio'), value: 'bio', width: '20%'},
                {text: '', value: 'actions'},
            ]);

            // Add / Edit Speaker Item
            const editSpeakerItemDialogShown = ref(false);
            const isNewMember = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const isEditSpeakerItemFormValid = ref(false);
            const editingSpeakerItem = ref(new SpeakerItem({fSpeakerId: props.speakerId}));

            const currentStart = ref(0); // Holds the index of starting item in speakerItemList in the current page of v-table

            const editOrderSpeakers = ref([]);
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const overlay = ref(false);

            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            const initAddSpeakerItem = function () {
                editingSpeakerItem.value = new SpeakerItem({fSpeakerId: props.speakerId});
                editingSpeakerItem.value.order =  speakerItems.value.length + 1
                editSpeakerItemDialogShown.value = true;
                isNewMember.value = true
            };
            const initEditSpeakerItem = function (speakerItem) {
                editingSpeakerItem.value = lodash.cloneDeep(speakerItem); // Perform Deep Copy
                editSpeakerItemDialogShown.value = true;
                isNewMember.value = false
            };
            const cancelEditSpeakerItem = function(){
                editSpeakerItemDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
                isNewMember.value = false;
            }
            const deleteSpeakerItem = function (speakerItem) {
                if (confirm(root.$t('speaker_item.confirm_delete'))) {
                    speakerItem.remove().then(() => {
                    }, root.$handleFeatherError.bind(root));
                }
            };

            const swappedOrderItem = function(value){
                let index = -1;
                let valueIndex =  -1;
                for(let i=0;i<speakerItems.value.length;i++){
                    if(speakerItems.value[i].order === parseInt(value.order)){
                        index = i;
                    }
                    if(speakerItems.value[i].id === value.id){
                        valueIndex = i;
                    }
                }
                if(index !== -1 && valueIndex !==-1){
                    return {
                        id: speakerItems.value[index].id,
                        order:speakerItems.value[valueIndex].order
                    };
                }else{
                    return null;
                }
            }

            const saveSpeakerItem = async function () {
                try {
                    if (editingSpeakerItem.value.photo instanceof File) {
                        editingSpeakerItem.value.photo = {src: await root.$uploadFile(editingSpeakerItem.value.photo)};
                    }
                    if (!editingSpeakerItem.value.photo) {
                        editingSpeakerItem.value.photo = null;
                    }

                    const item = swappedOrderItem(editingSpeakerItem.value);

                    if(item){
                        const updateItem = new SpeakerItem({
                            id: item.id,
                            order:item.order
                        });
                        await updateItem.patch(); // Update it to server side using Feather
                        await SpeakerItem.get(updateItem.id); // Retrieve the updated version and update on the local cache
                    }
                    editingSpeakerItem.value.save().then(() => {
                        SpeakerItem.get(editingSpeakerItem.value.id).then(()=>{
                            editSpeakerItemDialogShown.value = false;
                            root.$store.dispatch('showSnackBar', root.$t('speaker_item.save_successful'));
                        });
                    }, root.$handleFeatherError.bind(root));
                } catch (e) {
                    root.$handleFeatherError(e);
                }
            };

            const speakerOrderRule = function(value) {
                const onlyNumberRule = /^[0-9]+$/; // Regular Expression (Regex) rule
                return onlyNumberRule.test(value) || 'Invalid Number'; // Invalid Number is the error shown when no number is shown
            }

            const speakerOrderRule2 = function(value){
                let length = speakerItems.value.length;
                console.log("ruleTriggered")
                let isTrue = false;
                if(isNewMember.value){
                    isTrue = (value==length+1)
                    console.log("isNewMember:",value,length+1,isTrue)
                }else{
                    isTrue = (value<=length)
                    console.log("not:",value,length,isTrue)

                }
                return (isTrue && value!=0) || 'Number out of range';
            }

            const speakerOrderRule3 = function(value){
                return orderDoesntExistInList(value) || 'Order already exists';
            }

            const orderDoesntExistInList = function(value){
                for(let i=0;i<speakerItems.value.length;i++){
                    if(speakerItems.value[i].order===parseInt(value) && editingSpeakerItem.value.id != speakerItems.value[i].id){
                        return false;
                    }
                }
                return true;
            }
            
            const initEditOrder = function() {
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderSpeakers.value = lodash.cloneDeep(speakerItems.value);
            }
            const saveEditOrder = async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                for(let i=0;i<editOrderSpeakers.value.length;i++){
                    await editOrderSpeakers.value[i].save().then(()=>{
                        SpeakerItem.get(editOrderSpeakers.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false;
            }

            const tableSpeakers = computed(()=>{
                return isEditOrderMode.value? editOrderSpeakers.value:speakerItems.value;
            })
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderSpeakers.value.splice(oldIndex,1)[0];
                            editOrderSpeakers.value.splice(newIndex,0,rowSelected);

                            didOrderChange.value = true
                            for(let i=0;i<editOrderSpeakers.value.length;i++){
                                editOrderSpeakers.value[i].order = i+1
                            }
                        }
                    }
                )
            });

            return {
                speakerItems,
                tableSpeakers,
                isSpeakerItemPending,
                
                headers,

                editSpeakerItemDialogShown,
                confirmCancelItemDialogShown,
                initAddSpeakerItem,
                initEditSpeakerItem,
                cancelEditSpeakerItem,
                deleteSpeakerItem,
                isEditSpeakerItemFormValid,
                editingSpeakerItem,
                saveSpeakerItem,
                speakerOrderRule,
                speakerOrderRule2,
                speakerOrderRule3,

                currentPagination,

                overlay,
                isEditOrderMode,
                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                DateTime,
                getFileUrl: root.$getFileURL,

                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 2000
                },
                showEditor,
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>
